module.exports = __webpack_public_path__ + "static/media/yoga3.d8f7cd68.gif";